const analyseTopMenuSports = ['1', '2', '5', '6', '8', '43', '50'];

const createTopMenuCatcherKey = (gameId: string) => {
	let nextAnalyseKey = 'switch-to-odds-page-via-top-menu';
	
	if (analyseTopMenuSports.includes(gameId)) {
		nextAnalyseKey = `${nextAnalyseKey}-${gameId}`;
	}

	return nextAnalyseKey;
};

export const catcherAnalyseService = {
	createTopMenuCatcherKey
};